// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATIONS = {
  ctpOptIn: 'ctpOptIn',
  ctpFamilyUpsell: 'ctpFamilyUpsell',
} as const;
